import React, { useEffect } from 'react'
import Ticket from './components/Ticket'
import styles from './Tickets.module.css'
import { NavLink, useNavigate } from 'react-router-dom'
import Loader from '../subsidiary/Loader/Loader'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTickets } from './ticketSlice'
import HelpIcon from '@mui/icons-material/Help';

const Tickets = () => {
  const tickets = useSelector(state => state.ticketSlice.tickets)
  const token = useSelector(state => state.loginSlice.token)
  const isLoaded = useSelector(state => state.loginSlice.isLoaded)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchTickets({ token }))
  }, [dispatch, token])
  let navigate = useNavigate()
  return (
    <> {isLoaded ?
      <>
        <section className="main">
          <div className="content-wrapper">
            <div className="page-title-container">
              <h1 className="page-title ">
                Вопрос ОППО
              </h1>
            </div>
              <div style={{marginBottom: '50px'}}>В этом разделе Вы можете задать ОППО любой интересующий Вас вопрос или оставить свои предложения. Ваше мнение очень важно для нас!</div>
              <div style={{ paddingBottom: '60px', position: 'realtive' }}>
                {tickets
                  ?.slice()
                  .reverse()
                  .map((ticket, i) => (
                    <NavLink
                      key={i.toString()}
                      to={`/tickets/${ticket.id}`}
                      className={styles.ticketLink}
                    >
                      <Ticket ticket={ticket} />
                    </NavLink>
                  ))}
              </div>
          </div>
          <div className={styles.button_container}>
            <div
              className={styles.ticket_button}
              onClick={() => { navigate('/tickets/newticket') }}
            >
              Создать
            </div>
          </div>
        </section>
      </> : <Loader />}
    </>

  )
}
export default Tickets
